export default {
  titleTrigger: 'Don´t worry!, we´ll do it automatically',
  subTitleTrigger: 'Create automatic actions for those repetitive tasks',
  btnTrigger: 'Add an action',
  allActions: 'View active triggers',
  triggerWhen: 'I want that when...',
  happenThis: '...this happens',
  labelAction: 'Action name',
  labelDescription: 'Action description',
  actions: 'Actions',
  active: 'Active',
  createAction: 'Create an action',
  pickAJourneyStatus: 'Pick a journey status',
  customActionToFilter: 'Custom action to filter',
  journeys: 'Status',
  assignNewTask: 'Assign a new task!',
  timeInMinutesToCompleteTask: 'Time in minutes (numbers) to complete task',
  writeASubjectForYourEmail: 'Write a subject for your email',
  writeEmailInfo: 'Enter the information details for you email',
  enterPersonsEmail: 'Enter the email address you want to send the message to',
  enterPersonsName: 'Enter the name of the person you are sending the message to (Optional)',
  enterSenderName: 'Enter the sender´s name',
  sendPostRequest: 'Send a POST request to the server',
  sendNpsToUser: 'Send a CSAT to the user',
  sendSmsAutomatically: 'Send SMS automatically',
  sendWsAutomatically: 'Send WhatsApp automatically',
  allowUserParameters: 'Allow user parameters',
  activationEvent: 'Activation event',
  leaveFieldEmptyParameter: 'Leave this field empty if you´ll like to send the event by default',
  aditionalParameterBot: 'Bot aditional parameter',
  leaveFieldEmptyBot: 'Leave this field empty if you´ll like to send the parameter by default',
  executeAction: 'Executes action',
  triggerReach: 'Trigger reach',
  executeReaction: 'Executes reaction',
  sendWhatsappTo: 'Send whatsapp to specific phone',
  type: 'Type',
  pending: 'Pending',
  postponed: 'Postponed',
  terminated: 'Terminated',
  inWhiteList: 'Whitelisted',
  inBlackList: 'Blacklisted',
  opened: 'Opened',
  clicked: 'Clicked',
  inSpam: 'In spam',
  hardRebound: 'Hard rebound',
  softRebound: 'Soft rebound',
  rejected: 'Rejected',
  sent: 'Sent',
  received: 'Recieved',
  deliveredToCarrier: 'Delivered to carrier',
  whatsapp: 'WhatsApp',
  sms: 'SMS',
  request: 'Request',
  seeArchivedActions: 'See archived actions',
  archive: 'Archive',
  triggerSuccessfullyArchived: 'Action successfully archived',
  noName: 'No name',
  noDescription: 'No description',
  youCanAddMoreTriggers: 'You can add more than one trigger',
  addMoreEvents: 'Add more events',
  youMustEnterATitleAndADescription: 'You must enter a title and a description',
  youMustFillAllFieldsOfOpportunity: 'For the opportunity to be saved, all fields must be filled out',
  youMustAddTriggersOrEvents: 'In order to save, triggers and events must be entered',
  actionCreated: 'Action succesfully created',
  csatCreated: 'CSAT service succesfully created',
  selectTheOpportunity: 'Select an opportunity',
  selectTheEvent: 'Select the event',
  selectAnExtradata: 'Select a custom field',
  enterExtradataValue: 'Enter a value',
  selectTheForm: 'Select the form',
  selectJourneyStatus: 'Select the status',
  selectTempleteTypeCsat: 'Select the template for the CSAT',
  selectWhatsappTemplate: 'Select the template for your message',
  selectUserHost: 'Select a phone number',
  selectTempleteTypeCsatActive: 'Select the template',
  inputCustomCsatMessage: 'Enter the message you wish to send as CSAT',
  sendNPSToUser: 'Send CSAT to user',
  selectTaskType: 'Select task type (optional)',
  selectReminderTime: 'Select the time for the reminder',
  minutesBefore: 'minutes before',
  minutesAfter: 'minutes after',
  hourBefore: 'hours before',
  hourAfter: 'hours after',
  dayBefore: 'day before',
  dayAfter: 'day after',
  theMomentTheTaskIsAccomplished: 'The moment the task is completed',
  noUserDefinedMessage: 'This user doesn\'t have a defined message',
  youAreSeeingTheMessageOf: 'You are seeing the message of',
  messagePart: 'Message parts',
  writeYourSearch: 'Write your search',
  smsToUser: 'Send customized SMS',
  sendEmailTo: 'Send email to an specific person',
  sendSmsTo: 'Send sms to an specific person',
  emailToUser: 'Send customized email',
  whatsappToUser: 'WhatsApp to user',
  postRequestToServer: 'Send POST request to the server',
  createTaskForUser: 'Create a task',
  createOpportunityForUser: 'Create an opportunity',
  ACTION_CUSTOM: 'Custom action',
  ACTION_REGISTER_EMAIL: 'On email register',
  ACTION_REGISTER_PHONE: 'On phone register',
  ACTION_REGISTER_VERIFIED: 'On register verified',
  ACTION_REGISTER_EMAIL_RESEND: 'On resending register email',
  ACTION_REGISTER_SOCIAL: 'On register with social networks',
  ACTION_REGISTER_GOOGLE: 'On register with Google',
  ACTION_REGISTER_FACEBOOK: 'On register with Facebook',
  ACTION_REGISTER_SPOTIFY: 'On register with Spotify',
  ACTION_REGISTER_INSTAGRAM: 'On register with Instagram',
  ACTION_REGISTER_APPLEID: 'On register with AppleId',
  ACTION_REGISTER_EMAIL_FAIL: 'On register with email fails',
  ACTION_REGISTER_PHONE_FAIL: 'On register with phone fails',
  ACTION_LOGIN_EMAIL: 'On email login',
  ACTION_LOGIN_PHONE: 'On phone login',
  ACTION_LOGIN_SOCIAL: 'On login with social networks',
  ACTION_LOGIN_GOOGLE: 'On login with Google',
  ACTION_LOGIN_FACEBOOK: 'On login with Facebook',
  ACTION_LOGIN_INSTAGRAM: 'On login with Instagram',
  ACTION_LOGIN_SPOTIFY: 'On login with Spotify',
  ACTION_LOGIN_APPLEID: 'On login with AppleId',
  ACTION_LOGIN_MAIL_ONE_TIME_PASSWORD: 'On login with email and one time password',
  ACTION_LOGIN_MAIL_ONE_TIME_PASSWORD_FAIL: 'On login with email and one time password fails',
  ACTION_LOGIN_PHONE_ONE_TIME_PASSWORD: 'On login with phone and one time password',
  ACTION_LOGIN_PHONE_ONE_TIME_PASSWORD_FAIL: 'On login with phone and one time password fails',
  ACTION_LOGIN_EMAIL_FAIL: 'On email login fails',
  ACTION_LOGIN_EMAIL_FAIL_USER: 'On administrator email login fails',
  ACTION_LOGIN_EMAIL_FAIL_AUTHS: 'On email login fails in authentication',
  ACTION_LOGIN_EMAIL_FAIL_WRONG_PSW: 'On email login fails by wrong password',
  ACTION_LOGIN_PHONE_FAIL: 'On phone login fails',
  ACTION_LOGIN_PHONE_FAIL_USER: 'On administrator phone login fails',
  ACTION_LOGIN_PHONE_FAIL_AUTHS: 'On phone login fails in authentication',
  ACTION_LOGIN_PHONE_FAIL_WRONG_PSW: 'On phone login fails by wrong password',
  ACTION_RESET_PASSWORD_PHONE: 'On reset password with phone',
  ACTION_RESET_PASSWORD_EMAIL: 'On reset password with email',
  ACTION_RESET_VALIDATION: 'On reset validation',
  ACTION_A_CONVERSATION_END: 'when a cnversation ends',
  ACTION_RESET_OTP: 'On reset otp',
  ACTION_LOGOUT: 'On logout',
  ACTION_SUBMIT: 'On form submit',
  ACTION_SUBMIT_FILE: 'On form file submit',
  ACTION_USER_IMAGE: 'On user image changes',
  ACTION_EVENT_PURCHASE: 'On event ticket purchase',
  ACTION_EVENT_PURCHASE_CONFIRMATION: 'On event ticket purchase confirmation',
  ACTION_USER_CHANGE: 'On person created or modified',
  ACTION_ON_JOURNEY_SET: 'On Journey set',
  ACTION_ON_EXTRADATA_FIELD_CHANGE: 'On extra data field changes',
  ACTION_ON_EXTRADATA_VALUE_CHANGE: 'On extra data value changes',
  ACTION_ON_FORM_SUBMITTED: 'On form submitted',
  ACTION_ON_TASK_COMPLETED: 'When a task is completed',
  ACTION_ON_TASK_CREATED: 'When a task is created',
  ACTION_ON_TASK_SCHEDULED_REMINDER: 'When the time for a task is completed',
  ACTION_EVENT_CHECKIN: 'When the person checks in to the event',
  ACTION_ON_OPPORTUNITY_STEP_UPDATE: 'When an opportunity step changes',
  ACTION_ON_OPPORTUNITY_CREATED: 'When an opportunity is created',
  smsToResponsible: 'Send SMS to contact owner',
  emailToResponsable: 'Send Email to contact owner',
  whatsappToResponsible: 'Whatsapp to contact owner',
  allowSpecialCharactersAndEmojis: 'Allow special characters and emojis',
  noAutomatedResponses: 'You haven\'t automated your responses yet!',
  letsStart: 'Let\'s start',
  personalizeYourMessage: 'Personalize your message',
  messagePreview: 'Message preview',
  addNew: 'Add new',
  anyone: 'Any',
  noTag: 'No Tag',
  botChannelSetting: 'Toggle this on if you want the autobot to take over the conversations from this channel',
  customizeWithName: 'Customize with name',
  tagHandoffTooltip: 'Toggle this on if you want the autobot to transfer conversations matching this category. This action applies to the selected category: ',
  botIs: 'Your bot is ',
  for: 'for ',
  comingSoonFeature: 'Coming soon...',
  autobotBuyTooltip: 'The bot will determine if it has received a request related to product purchases. When this is the case, it looks up to see if it has a response message configured in the submenu items that it can answer with, and if not, it uses the message configured for the purchase template.',
  sendBotMenu: 'Send menu options to the end user after welcome message',
  botSummaryTitle1: 'Configured',
  botSummaryTitle2: 'messages',
  botIsLive: 'The bot is live',
  botIsNotLive: 'The bot is not live',
  yourBotIsActive: 'Your bot is activated',
  youCanEditYourBot: 'You can edit it whenever you want, to add new responses and interactions',
  yourBotIsDisconnected: 'Your bot is disconnected',
  botActive: 'Your bot is activated',
  botCreated: 'Your bot has been created and is ready to be activated',
  setup: 'Setup',
  yourBot: 'Your bot',
  botInactive: 'Your bot is offline',
  writeBotTestMessage: 'Write a message to test your bot',
  thisAreYourBasicMessages: 'These are your basic messages, customize them however you want',
  letsTry: 'Lets try!',
  yourAboutToFinish: 'Youre about to finish!',
  yourMessageHasSpecialCharacters: 'Your message has special characters, because of this the total cost of your campaign will be affected',
  yourMessageHasMoreThan67Characters: 'Your message has more than 67 characters per SMS, because of this the number of SMS sent will be affected',
  yourMessageHasSpecialFields: 'Your message has special fields, because of this the total cost of your campaign will be affected',
  automateYourResponses: 'Configure your Autobots',
  setupBotFashionRetail: 'Setup your bot for fashion retail',
  whyToAutomate: 'Automating customer interactions does not have to come at the cost of losing the personal touch. By selecting the appropriate type of bot and customizing it with your own language and tone, you can maintain a strong connection with your customers while streamlining your processes. Let\'s start',
  write: 'Type a message',
  campaignSender: 'Type the name of the campaign sender',
  emailSubject: 'Type your email subject',
  pressEnterToSelect: 'Press enter to select',
  templateMessagesType: 'Messages type',
  setupBot: 'Setup your bot!',
  essencialBotText: 'Configure your Essential Bot',
  retailBotText: 'Configure your Retail Bot',
  beautyBotText: 'Configure your Beauty & Cosmetics Bot',
  foodBotText: 'Configure your Food Delivery Bot',
  es_plantilla_mensaje_handoff_online: 'Active',
  es_plantilla_mensaje_handoff_offline: 'Inactive',
  es_submenu_categoria_productos: 'Products',
  es_submenu_categoria_departamentos: 'Departments',
  transferences: 'Autoassign'
}
